import styled from 'styled-components';

export const StaticPagesContainer = styled.div`
    font-family: 'Frank Ruhl Libre', serif;
    margin: auto;
`;
